const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9 \-_/().&,#'+]+$/,
  NUMERIC: /^[0-9]+$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};

export const formElementFields = [
  {
    id: "type",
    label: "Type",
    placeHolder: "Select type",
    type: "select",
    md: 4,
    isRequired: true,
    options: [],
  },
  {
    id: "title",
    label: "Title",
    placeHolder: "Enter task title",
    type: "text",
    md: 4,
    inputProps: {
      maxLength: 200,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
  {
    id: "complaint_id",
    label: "Complaint",
    placeHolder: "Select",
    type: "select",
    md: 4,
    isRequired: true,
    options: [], // Will be populated dynamically with complaints
    disabled: true, // Initially disabled until complaints are loaded
  },
  {
    id: "progress_id",
    label: "Progress Items",
    placeHolder: "Select",
    type: "select",
    md: 4,
    isRequired: false,
    options: [], // Will be populated dynamically with progress items related to selected complaint
    // disabled: true, // Initially disabled until a complaint is selected
  },
  {
    id: "address",
    label: "Locations",
    placeHolder: "Select",
    type: "select",
    md: 4,
    isRequired: false,
    options: [], // Will be populated dynamically with locations
  },
  {
    id: "status",
    label: "Status",
    placeHolder: "Select",
    type: "select",
    md: 4,
    isRequired: false,
    options: ["Pending", "In Progress", "Completed","Cancelled"],
  },
  {
    id: "description",
    label: "Description",
    placeHolder: "Enter task description",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 500,
      rows: 3,
    },
    isRequired: false,
  },

  {
    id: "date",
    label: "Date",
    placeHolder: "Select date",
    type: "date",
    md: 4,
    isRequired: true,
  },
  {
    id: "start_time",
    label: "Start Time",
    placeHolder: "Select start time",
    type: "time",
    md: 4,
    isRequired: true,
  },
  {
    id: "end_time",
    label: "End Time",
    placeHolder: "Select end time",
    type: "time",
    md: 4,
    isRequired: false,
  },
  {
    id: "assigned_to",
    label: "Assigned To",
    placeHolder: "Select assigned person",
    type: "select",
    md: 12,
    options: [], // Will be populated dynamically with users
    isRequired: false,
  },
  {
    id: "notified_emails",
    label: "Email",
    placeHolder: "Enter email addresses (separate multiple with semicolon)",
    type: "emailChip",
    md: 12,
    inputProps: {
      maxLength: 500,
    },
    isRequired: false,
  },
];
